<div *ngIf="loading" class="superloader">
    <img [src]="loaderGifPath()" width="80px" />
</div>
<ng-container *ngIf="isPublicCloudInvitation && !isSuccess">
    <app-invitation-public-cloud-create-password></app-invitation-public-cloud-create-password>
</ng-container>
<!-- B2B Partner -->
<ng-container *ngIf="(isB2BPartnerInvitation || isB2BPartnerInvitationError) && !isSuccess">
    <app-invitation-b2b-partner [invitation]="invitation"></app-invitation-b2b-partner>
</ng-container>
<!-- B2B Client -->
<ng-container *ngIf="(isB2BCustomerInvitation || isB2BCustomerInvitationError) && !isSuccess">
    <app-invitation-b2b-client [invitation]="invitation"></app-invitation-b2b-client>
</ng-container>
<ng-container *ngIf="newDesign && !isSuccess">
    <app-signup-v2></app-signup-v2>
</ng-container>
<ng-container
    *ngIf="
        !isSuccess &&
        !newDesign &&
        !isPublicCloudInvitation &&
        !(isB2BPartnerInvitation || isB2BPartnerInvitationError) &&
        !(isB2BCustomerInvitation || isB2BCustomerInvitationError)
    "
>
    <div
        *ngIf="!checkService.isConnected() && imgLoaded && !state.includes('order') && !webmailPassword && !loading"
        class="relative header--container theme-white-1-background"
    >
        <div class="header--row">
            <signup-language-switcher></signup-language-switcher>
        </div>
    </div>
    <div
        *ngIf="!isInErrorState() && !loading && !webmailPassword"
        [class.signup-landing--order]="state.includes('order')"
        [hidden]="!imgLoaded && !checkService.isKsuiteInvitation()"
        class="signup-landing theme-white-1-background"
    >
        <header class="container signup-landing__header">
            <div class="row">
                <div *ngIf="checkService.isKsuiteInvitation()" class="col-12 col-md-1"></div>
                <div class="col-12 col-md-6 signup-landing__header__left-block">
                    <!-- GROUP LOGO -->
                    <div *ngIf="!state.includes('order')" class="signup-landing__header__img">
                        <img
                            *ngIf="invitation && invitation.account && invitation.account.logo"
                            [src]="invitation.account.logo"
                            alt="Infomaniak"
                            class="margin-bottom-20"
                        />
                        <img
                            *ngIf="!invitation || !invitation.account"
                            [src]="brandingLogoPath"
                            alt="Infomaniak"
                            class="margin-bottom-20"
                        />
                        <span
                            *ngIf="invitation && invitation.account && !invitation.account.logo"
                            [innerHTML]="invitation.account.organization_name | escapeHtml"
                            class="account-name"
                        >
                        </span>
                    </div>

                    <!-- BODY STANDARD INVITATION ( ALL TYPE BUT KSUITE ) -->
                    <div *ngIf="!checkService.isKsuiteInvitation()" class="signup-landing__col">

                        <h1 *ngIf="checkService.isInTransfer()">
                            {{
                                '$name$ vous transfert un produit'
                                    | transloco
                                        : {
                                              name: invitation.account.organization_name | escapeHtml
                                          }
                            }}
                        </h1>
                        <h1 *ngIf="!checkService.isInTransfer() && !invitationDetails()">
                            {{ 'Bienvenue chez Infomaniak !' | transloco }}
                        </h1>
                        <h1
                            *ngIf="!checkService.isInTransfer() && invitationDetails()"
                            [innerHTML]="invitationDetails() && invitationDetails().title"
                        ></h1>
                        <p
                            *ngIf="!checkService.isInTransfer() && !invitationDetails()"
                            [innerHTML]="landingHeaderBaseWording"
                            class="bottom-sm-30"
                        ></p>
                        <p
                            *ngIf="!checkService.isInTransfer() && invitationDetails()"
                            [innerHTML]="invitationDetails().p"
                            class="bottom-sm-30"
                        ></p>
                        <p *ngIf="checkService.isInTransfer()" class="bottom-sm-30">
                            {{
                                'Creez votre compte ou connectez-vous afin de pouvoir finaliser le transfert'
                                    | transloco
                            }}
                        </p>
                    </div>

                    <!-- BODY KSUITE SPECIFIC INVITATION -->
                    <div *ngIf="checkService.isKsuiteInvitation()" class="signup-landing__col">
                        <!-- EMAIL IS FORCED FOR SIGNUP NOT FOR AN EXISTING USER -->
                        <ng-container
                            *ngIf="checkService.isEmailForced() && !checkService.isKsuiteInvitationForExistingUser()"
                        >
                            <div class="signup-landing__col__ksuite-title">
                                <strong>{{
                                    '$accountName$ vous invite a creer un compte pour rejoindre :'
                                        | transloco : { accountName: invitation.account.organization_name }
                                }}</strong>
                                <div class="signup-landing__col__ksuite-title__subline">
                                    <img
                                        class="signup-landing__col__ksuite-title__subline__ksuite-logo"
                                        src="/assets/images/ksuite/ksuite-logo-only.svg"
                                    />
                                    <span class="signup-landing__col__ksuite-title__subline__ksuite secondary-text"
                                        >kSuite</span
                                    >
                                    <strong class="signup-landing__col__ksuite-title__subline__ksuite-name">{{
                                        getInvitationKsuiteName()
                                    }}</strong>
                                </div>
                            </div>

                            <!-- EMAIL FORCED IS FROM KSUITE -->
                            <div
                                *ngIf="getInvitationKsuiteEmailOfKsuite()"
                                class="signup-landing__col__ksuite-subtitle"
                            >
                                <div class="signup-landing__col__ksuite-subtitle__line1--classic secondary-text">
                                    {{ "L'adresse mail suivante a ete cree pour vous :" | transloco }}&nbsp;<strong
                                        class="bold-medium"
                                        >{{ getInvitationKsuiteEmailOfKsuite() }}</strong
                                    >
                                </div>
                                <div class="signup-landing__col__ksuite-subtitle__line2 margin-top-20 margin-bottom-20">
                                    {{
                                        'En creant votre compte, vous rejoindrez la kSuite $kSuiteName$ et vous serez un collaborateur de cette organisation.'
                                            | transloco : { kSuiteName: getInvitationKsuiteName() }
                                    }}
                                </div>
                            </div>

                            <!-- EMAIL FORCED IS NOT FROM KSUITE -->
                            <div
                                *ngIf="!getInvitationKsuiteEmailOfKsuite()"
                                class="signup-landing__col__ksuite-subtitle"
                            >
                                <div
                                    [innerHTML]="
                                        'Nous avons choisis l\'adresse suivante : <strong>$emailInvitation$</strong> pour la creation de votre compte kSuite.'
                                            | transloco : { emailInvitation: getInvitationEmail() }
                                    "
                                    class="signup-landing__col__ksuite-subtitle__line1"
                                ></div>
                                <div class="signup-landing__col__ksuite-subtitle__line2">
                                    {{
                                        'Si vous possedez deja un compte chez Infomaniak, veuillez vous connecter avec cette adresse mail. Autrement, nous vous invitons a creer un compte a partir de cette adresse pour accepter cette invitation.'
                                            | transloco
                                    }}
                                </div>
                            </div>
                        </ng-container>

                        <!-- EMAIL IS NOT FORCED FOR SIGNUP AND NOT FOR AN EXISTING USER -->
                        <ng-container
                            *ngIf="!checkService.isEmailForced() && !checkService.isKsuiteInvitationForExistingUser()"
                        >
                            <div class="signup-landing__col__ksuite-title--inline">
                                <strong>{{
                                    '$accountName$ vous invite a rejoindre :'
                                        | transloco : { accountName: invitation.account.organization_name }
                                }}</strong>
                                <div class="signup-landing__col__ksuite-title__subline">
                                    <img
                                        class="signup-landing__col__ksuite-title__subline__ksuite-logo"
                                        src="/assets/images/ksuite/ksuite-logo-only.svg"
                                    />
                                    <span class="signup-landing__col__ksuite-title__subline__ksuite secondary-text"
                                        >kSuite</span
                                    >
                                    <strong class="signup-landing__col__ksuite-title__subline__ksuite-name">{{
                                        getInvitationKsuiteName()
                                    }}</strong>
                                </div>
                            </div>
                            <div class="signup-landing__col__ksuite-subtitle">
                                <div
                                    *ngIf="getInvitationKsuiteEmailOfKsuite()"
                                    class="signup-landing__col__ksuite-subtitle__line1--classic secondary-text"
                                >
                                    {{ "L'adresse mail suivante a ete cree pour vous :" | transloco }}&nbsp;<strong
                                        class="bold-medium"
                                        >{{ getInvitationKsuiteEmailOfKsuite() }}</strong
                                    >
                                </div>
                                <div *ngIf="!checkService.isConnected() && !getInvitationKsuiteEmailOfKsuite()">
                                    {{
                                        "Vous pouvez creer un nouveau compte ou vous connecter sur un compte existant pour accepter l'invitation"
                                            | transloco
                                    }}
                                </div>
                                <div
                                    *ngIf="
                                        getInvitationKsuiteEmailOfKsuite() &&
                                        invitation.status !== 'user_already_in_ksuite' &&
                                        checkService.isConnected()
                                    "
                                    class="signup-landing__col__ksuite-subtitle__line-password-input"
                                >
                                    <div class="signup-landing__col__ksuite-subtitle__line-password-input__text">
                                        {{
                                            'Choisissez le nouveau mot de passe que vous souhaitez attribuer a cette adresse mail :'
                                                | transloco
                                        }}
                                    </div>
                                    <form
                                        [formGroup]="form"
                                        class="form margin-top-20 margin-bottom-10 signup-landing__col__ksuite-subtitle__line-password-input__form"
                                    >
                                        <ik-password-input
                                            (generate)="generate($event)"
                                            [classes]="
                                                'ik-form-field password-field signup-landing__col__ksuite-subtitle__line-password-input__form__password'
                                            "
                                            [iconGeneratePassword]="'icon-rotation-lock'"
                                            [iconHidePassword]="' icon-eye-crossed'"
                                            [iconSeePassword]="'icon-eye'"
                                            [label]="'Mot de passe' | transloco"
                                            [minLength]="8"
                                            [placeholder]="'Mot de passe' | transloco"
                                            [showGenerate]="true"
                                            autocomplete="password"
                                            formControlName="password"
                                            matInput
                                            name="password"
                                            type="text"
                                        >
                                        </ik-password-input>
                                        <div
                                            class="signup-landing__col__ksuite-subtitle__line-password-input__validation"
                                        >
                                            <ik-validation-check
                                                [description]="'Minuscule' | transloco"
                                                [label]="'a'"
                                                [tooltipMessage]="'Au moins une minuscule' | transloco"
                                                [valid]="passwordValidation.lowerCase"
                                            >
                                            </ik-validation-check>
                                            <ik-validation-check
                                                [description]="'Majuscule' | transloco"
                                                [label]="'A'"
                                                [tooltipMessage]="'Au moins une majuscule' | transloco"
                                                [valid]="passwordValidation.upperCase"
                                            >
                                            </ik-validation-check>
                                            <ik-validation-check
                                                [description]="'Chiffre' | transloco"
                                                [label]="'0 - 9'"
                                                [tooltipMessage]="'Au moins un chiffre' | transloco"
                                                [valid]="passwordValidation.number"
                                            >
                                            </ik-validation-check>
                                            <ik-validation-check
                                                [description]="'Caracteres' | transloco"
                                                [label]="'8+'"
                                                [tooltipMessage]="
                                                    '$number$ caracteres ou plus' | transloco : { number: 8 }
                                                "
                                                [valid]="passwordValidation.characterCount"
                                            >
                                            </ik-validation-check>
                                        </div>
                                    </form>
                                    <mat-error *ngIf="form.get('password').hasError('maxlength')">
                                        *
                                        {{ 'La taille maximum de ce champ est de 72 caracteres' | transloco }}
                                    </mat-error>
                                    <mat-error
                                        *ngIf="displayFormError"
                                        [innerHTML]="getValidationErrorMessage()"
                                        class="hintError"
                                    ></mat-error>
                                </div>
                            </div>
                        </ng-container>

                        <!-- INVITATION IS FOR AN EXISTING USER -->
                        <ng-container *ngIf="checkService.isKsuiteInvitationForExistingUser()">
                            <div class="signup-landing__col__ksuite-title--inline">
                                <strong *ngIf="!isKsuiteUserMailbox()">{{
                                    '$accountName$ vous invite a rejoindre :'
                                        | transloco : { accountName: invitation.account.organization_name }
                                }}</strong>
                                <span class="signup-landing__col__ksuite-title__subline">
                                    <img
                                        class="signup-landing__col__ksuite-title__subline__ksuite-logo"
                                        src="/assets/images/ksuite/ksuite-logo-only.svg"
                                    />
                                    <span class="signup-landing__col__ksuite-title__subline__ksuite secondary-text"
                                        >kSuite</span
                                    >
                                    <strong class="signup-landing__col__ksuite-title__subline__ksuite-name">{{
                                        getInvitationKsuiteName()
                                    }}</strong>
                                </span>
                            </div>
                            <div
                                *ngIf="getInvitationKsuiteEmailOfKsuite()"
                                class="signup-landing__col__ksuite-subtitle"
                            >
                                <div class="signup-landing__col__ksuite-subtitle__line1--classic secondary-text">
                                    {{ "L'adresse mail suivante a ete cree pour vous :" | transloco }}&nbsp;<strong
                                        class="bold-medium"
                                        >{{ getInvitationKsuiteEmailOfKsuite() }}</strong
                                    >
                                </div>
                            </div>
                            <div
                                *ngIf="
                                    getInvitationKsuiteEmailOfKsuite() &&
                                    isPasswordAsk() &&
                                    invitation.status !== 'user_already_in_ksuite' &&
                                    checkService.isConnected()
                                "
                                class="signup-landing__col__ksuite-subtitle__line-password-input"
                            >
                                <div
                                    *ngIf="!isKsuiteUserMailbox()"
                                    class="signup-landing__col__ksuite-subtitle__line-password-input__text"
                                >
                                    {{
                                        'Choisissez le nouveau mot de passe que vous souhaitez attribuer a cette adresse mail :'
                                            | transloco
                                    }}
                                </div>
                                <div
                                    *ngIf="isKsuiteUserMailbox()"
                                    class="signup-landing__col__ksuite-subtitle__line-password-input__text margin-top-20"
                                >
                                    {{
                                        'Veuillez choisir un mot de passe pour pouvoir y acceder depuis kMail:'
                                            | transloco
                                    }}
                                </div>
                                <form
                                    [formGroup]="form"
                                    class="form margin-top-20 margin-bottom-10 signup-landing__col__ksuite-subtitle__line-password-input__form"
                                >
                                    <ik-password-input
                                        (generate)="generate($event)"
                                        [classes]="
                                            'ik-form-field password-field signup-landing__col__ksuite-subtitle__line-password-input__form__password'
                                        "
                                        [iconGeneratePassword]="'icon-rotation-lock'"
                                        [iconHidePassword]="' icon-eye-crossed'"
                                        [iconSeePassword]="'icon-eye'"
                                        [label]="'Mot de passe' | transloco"
                                        [minLength]="8"
                                        [placeholder]="'Mot de passe' | transloco"
                                        [showGenerate]="true"
                                        autocomplete="password"
                                        formControlName="password"
                                        matInput
                                        name="password"
                                        type="text"
                                    >
                                    </ik-password-input>
                                    <div class="signup-landing__col__ksuite-subtitle__line-password-input__validation">
                                        <ik-validation-check
                                            [description]="'Minuscule' | transloco"
                                            [label]="'a'"
                                            [tooltipMessage]="'Au moins une minuscule' | transloco"
                                            [valid]="passwordValidation.lowerCase"
                                        >
                                        </ik-validation-check>
                                        <ik-validation-check
                                            [description]="'Majuscule' | transloco"
                                            [label]="'A'"
                                            [tooltipMessage]="'Au moins une majuscule' | transloco"
                                            [valid]="passwordValidation.upperCase"
                                        >
                                        </ik-validation-check>
                                        <ik-validation-check
                                            [description]="'Chiffre' | transloco"
                                            [label]="'0 - 9'"
                                            [tooltipMessage]="'Au moins un chiffre' | transloco"
                                            [valid]="passwordValidation.number"
                                        >
                                        </ik-validation-check>
                                        <ik-validation-check
                                            [description]="'Caracteres' | transloco"
                                            [label]="'8+'"
                                            [tooltipMessage]="'$number$ caracteres ou plus' | transloco : { number: 8 }"
                                            [valid]="passwordValidation.characterCount"
                                        >
                                        </ik-validation-check>
                                    </div>
                                </form>
                                <mat-error *ngIf="form.get('password').hasError('maxlength')">
                                    *
                                    {{ 'La taille maximum de ce champ est de 72 caracteres' | transloco }}
                                </mat-error>
                                <mat-error
                                    *ngIf="displayFormError"
                                    [innerHTML]="getValidationErrorMessage()"
                                    class="hintError"
                                ></mat-error>
                            </div>
                        </ng-container>

                        <div
                            *ngIf="checkService.isConnected() && invitation.status === 'user_already_in_ksuite'"
                            class="signup-landing__col__ksuite-subtitle__line2"
                        >
                            <ik-info-box [newBg]="true" iconClass="icon-warning warning margin-top-15">
                                <div class="signup-landing__col__ksuite-subtitle__line2__info-box-content">
                                    <strong>{{ 'Le compte suivant possede deja une kSuite.' | transloco }}</strong>
                                    <span>{{ 'Il ne peut y avoir 2 kSuite sur le meme compte.' | transloco }}</span>
                                    <span>{{
                                        'Veuillez-vous creer un nouveau compte ou, utiliser un autre compte non relie a une kSuite.'
                                            | transloco
                                    }}</span>
                                </div>
                            </ik-info-box>
                        </div>

                        <ng-container *ngIf="user.id && !isKsuiteUserMailbox()">
                            <div
                                *ngIf="
                                    checkService.isConnected() &&
                                    invitation.status !== 'user_already_in_ksuite' &&
                                    invitation.status !== 'pending_create'
                                "
                                class="signup-landing__col__ksuite-subtitle margin-top-20"
                            >
                                <div
                                    *ngIf="invitation.can_set_email"
                                    class="signup-landing__col__ksuite-subtitle__line1"
                                >
                                    {{ 'Souhaitez-vous rejoindre la kSuite avec ce compte ?' | transloco }}
                                </div>
                                <div
                                    *ngIf="!invitation.can_set_email"
                                    class="signup-landing__col__ksuite-subtitle__line1"
                                >
                                    {{ 'Vous avez ete invite a rejoindre kSuite avec ce compte :' | transloco }}
                                </div>
                            </div>

                            <div
                                [class.signup-landing__col__ksuite-user-connected-block--already-in]="
                                    invitation.status === 'user_already_in_ksuite'
                                "
                                class="signup-landing__col__ksuite-user-connected-block"
                            >
                                <div class="signup-landing__col__ksuite__user-connected-block__avatar">
                                    <ik-avatar
                                        [avatarName]="user.first_name + ' ' + user.last_name"
                                        [avatarUrl]="user.avatar_url"
                                        [id]="user.id"
                                    ></ik-avatar>
                                </div>
                                <div class="signup-landing__col__ksuite-user-connected-block__details">
                                    <div class="signup-landing__col__ksuite-user-connected-block__details__name">
                                        {{ user.first_name + ' ' + user.last_name }}
                                    </div>
                                    <div class="signup-landing__col__ksuite-user-connected-block__details__mail">
                                        {{ user.email }}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <!-- BUTTONS BLOCK -->
                    <signup-landing-buttons
                        (landingButtonAction)="onLandingButtonAction($event)"
                        [acceptIsPasswordRestricted]="isPasswordRestricted"
                        [isLoading]="loading"
                        [removeSidePaddings]="true"
                    >
                    </signup-landing-buttons>
                </div>

                <ng-container [ngSwitch]="state">
                    <!-- KSUITE SPECIFIC RIGHT BLOCK -->
                    <ng-container *ngSwitchCase="'invitation_ksuite'">
                        <div class="col-12 col-md-5">
                            <app-ksuite-info-block
                                [gradientBorder]="true"
                                [lightDisplay]="true"
                            ></app-ksuite-info-block>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'invitation_webmail_ksuite'">
                        <div class="col-12 col-md-5">
                            <app-ksuite-info-block
                                [gradientBorder]="true"
                                [lightDisplay]="true"
                            ></app-ksuite-info-block>
                        </div>
                    </ng-container>

                    <!-- STANDARD SLIDESHOW RIGHT BLOCK -->
                    <ng-container *ngSwitchDefault>
                        <div class="col-12 col-md-6 slideshow">
                            <div *ngIf="imagesDiplayed()" class="signup-landing__col">
                                <div
                                    *ngIf="imagesDiplayed().length > 1"
                                    [swiper]="imgLoaded ? swiperconf : null"
                                    class="swiper-container"
                                >
                                    <ng-container *ngTemplateOutlet="images"></ng-container>
                                </div>
                                <div *ngIf="imagesDiplayed().length === 1" class="swiper-container">
                                    <ng-container *ngTemplateOutlet="images"></ng-container>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <!-- ./row -->
        </header>
        <!-- ./header -->
        <signup-landing-footer></signup-landing-footer>
    </div>
    <signup-errors *ngIf="isInErrorState()"></signup-errors>
    <webmail-password *ngIf="webmailPassword"></webmail-password>
    <app-screen-loader [path]="loaderGifPath"></app-screen-loader>
    <ng-template #images>
        <div class="swiper-wrapper">
            <div *ngIf="imagesDiplayed().indexOf('mail') > -1" class="swiper-slide">
                <img
                    (load)="onImgLoaded()"
                    alt="Mail"
                    src="/assets/images/ui/tools-screens/mobile/mail_medium.jpg"
                    srcset="/assets/images/ui/tools-screens/desktop/mail_medium.jpg 720w"
                />
                <div *ngIf="!state.includes('order')" class="swiper-slide__shadows">
                    <div class="swiper-slide__shadow swiper-slide__shadow--1"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--2"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--3"></div>
                </div>
            </div>
            <div *ngIf="imagesDiplayed().indexOf('manager') > -1" class="swiper-slide">
                <img
                    (load)="onImgLoaded()"
                    alt="Manager"
                    src="/assets/images/ui/tools-screens/mobile/manager_medium.jpg"
                    srcset="/assets/images/ui/tools-screens/desktop/manager_medium.jpg 720w"
                />
                <div *ngIf="!state.includes('order')" class="swiper-slide__shadows">
                    <div class="swiper-slide__shadow swiper-slide__shadow--1"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--2"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--3"></div>
                </div>
            </div>
            <div *ngIf="imagesDiplayed().indexOf('drive') > -1" class="swiper-slide">
                <img
                    (load)="onImgLoaded()"
                    alt="Drive"
                    src="/assets/images/ui/tools-screens/mobile/drive_medium.jpg"
                    srcset="/assets/images/ui/tools-screens/desktop/drive_medium.jpg 720w"
                />
                <div *ngIf="!state.includes('order')" class="swiper-slide__shadows">
                    <div class="swiper-slide__shadow swiper-slide__shadow--1"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--2"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--3"></div>
                </div>
            </div>
            <div *ngIf="imagesDiplayed().indexOf('calendar') > -1" class="swiper-slide">
                <img
                    (load)="onImgLoaded()"
                    alt="Calendar"
                    src="/assets/images/ui/tools-screens/mobile/calendar_medium.jpg"
                    srcset="/assets/images/ui/tools-screens/desktop/calendar_medium.jpg 720w"
                />
                <div *ngIf="!state.includes('order')" class="swiper-slide__shadows">
                    <div class="swiper-slide__shadow swiper-slide__shadow--1"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--2"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--3"></div>
                </div>
            </div>
            <div *ngIf="imagesDiplayed().indexOf('kchat') > -1" class="swiper-slide">
                <img
                    (load)="onImgLoaded()"
                    alt="kChat"
                    src="/assets/images/ui/tools-screens/mobile/kchat_medium.png"
                    srcset="/assets/images/ui/tools-screens/desktop/kchat_medium.png 720w"
                />
                <div *ngIf="!state.includes('order')" class="swiper-slide__shadows">
                    <div class="swiper-slide__shadow swiper-slide__shadow--1"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--2"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--3"></div>
                </div>
            </div>
            <div *ngIf="imagesDiplayed().indexOf('contacts') > -1" class="swiper-slide">
                <img
                    (load)="onImgLoaded()"
                    alt="Contact"
                    src="/assets/images/ui/tools-screens/mobile/contacts_medium.jpg"
                    srcset="/assets/images/ui/tools-screens/desktop/contacts_medium.jpg 720w"
                />
                <div *ngIf="!state.includes('order')" class="swiper-slide__shadows">
                    <div class="swiper-slide__shadow swiper-slide__shadow--1"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--2"></div>
                    <div class="swiper-slide__shadow swiper-slide__shadow--3"></div>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>

<!-- SUCCESS PAGE FOR INVITATION WHEN SKIPREDIRECT IS TRUE -->
<ng-container *ngIf="isSuccess">
    <ng-container *ngIf="checkService.isKsuiteInvitation()">
        <div class="row full-height">
            <div class="col-12 full-height col-md-6 signup-success-left">
                <!-- GROUP LOGO -->
                <div *ngIf="!state.includes('order')">
                    <img
                        *ngIf="invitation && invitation.account && invitation.account.logo"
                        [src]="invitation.account.logo"
                        alt="Infomaniak"
                        class="margin-bottom-20"
                    />
                    <img
                        *ngIf="!invitation || !invitation.account"
                        [src]="'/assets/images/ui/logo-infomaniak.svg'"
                        alt="Infomaniak"
                        class="margin-bottom-20"
                    />
                    <span
                        *ngIf="invitation && invitation.account && !invitation.account.logo"
                        [innerHTML]="invitation.account.organization_name | escapeHtml"
                        class="account-name"
                    >
                    </span>
                </div>
                <div class="signup-success-left__user-name margin-bottom-40">
                    {{ 'Bienvenue, $userName$' | transloco : { userName: user.first_name } }}
                </div>
                <div class="signup-success-left__text margin-bottom-40">
                    {{
                        "Vous pouvez a present acceder a la kSuite $ksuiteName$ et a l'ensemble de ses applications."
                            | transloco : { ksuiteName: getInvitationKsuiteName() }
                    }}
                </div>
                <div class="signup-success-left__title-text margin-bottom-20">
                    {{ 'Les informations suivantes sont confidentielles :' | transloco }}
                </div>
                <div class="signup-success-left__title-text margin-bottom-10">
                    {{ 'Adresse kSuite :' | transloco }}
                </div>
                <div class="signup-success-left__text-block-inline margin-bottom-10">
                    <div class="signup-success-left__text-block-inline__text">
                        {{ 'Votre adresse mail kSuite :' | transloco }}
                    </div>
                    <div
                        class="signup-success-left__text-block-inline__block signup-success-left__text-block-inline__block__password-block__buttons"
                    >
                        <span class="signup-success-left__text-block-inline__text">
                            {{ getInvitationKsuiteEmailOfKsuite() }}
                        </span>
                        <button
                            (cbOnSuccess)="copied()"
                            [cbContent]="getInvitationKsuiteEmailOfKsuite()"
                            [position]="'above'"
                            [signupTooltip]="isMobile ? null : ('Copier l\'adresse mail' | transloco)"
                            class="icon icon-copy icon-size-14"
                            ngxClipboard
                        ></button>
                    </div>
                </div>
                <div class="signup-success-left__text-block-inline margin-bottom-10">
                    <div class="signup-success-left__text-block-inline__block">
                        <div class="signup-success-left__text-block-inline__block__password-block">
                            <span class="signup-success-left__text-block-inline__block__password-block__password">
                                {{ 'Votre mot de passe' | transloco }} :&nbsp;
                            </span>
                            <input
                                #passwordField
                                class="signup-success-left__text-block-inline__block__password-block__input"
                                disabled
                                type="{{ inputType }}"
                                value="{{ form.get('password').value }}"
                            />
                            <div class="signup-success-left__text-block-inline__block__password-block__buttons">
                                <button
                                    (click)="inputType = inputType === 'password' ? 'text' : 'password'"
                                    [position]="'above'"
                                    [signupTooltip]="isMobile ? null : ('Afficher le mot de passe' | transloco)"
                                    class="icon icon-eye icon-size-14"
                                ></button>
                                <button
                                    (cbOnSuccess)="copied()"
                                    [cbContent]="passwordField.value"
                                    [position]="'above'"
                                    [signupTooltip]="isMobile ? null : ('Copier le mot de passe' | transloco)"
                                    class="icon icon-copy icon-size-14"
                                    ngxClipboard
                                ></button>
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    (click)="returnToManager()"
                    class="mat-elevation-z margin-top-20 signup-success-left__button"
                    color="primary"
                    mat-flat-button
                >
                    {{ 'Acceder au manager' | transloco }}
                </button>
            </div>
            <div class="col-12 col-md-6 full-height signup-success-right"></div>
        </div>
    </ng-container>
</ng-container>
